import { 
    TitleLarge,
    TitleMedium,
    BodyRegular
} from '@/components/typography';
import { PrimaryButton } from '@/components/buttons';
import { TextBadge } from '@/components/elements';
import HeroImage from '@/assets/img/ui/9.png';

export const Transparency = () => {
    return (
        <div className="w-full bg-background">
            <section className="w-full flex justify-center px-4 py-16 lg:pt-44 relative">
                <div className="absolute inset-0 opacity-20 pointer-events-none">
                    {/* Star patterns */}
                </div>

                {/* Glow effects */}
                <div className="absolute left-1/4 top-1/4 w-96 h-96 opacity-60 bg-primary rounded-full blur-[247.13px] pointer-events-none" />
                <div className="absolute right-1/4 bottom-1/4 w-96 h-96 opacity-60 bg-cyan-400 rounded-full blur-[282.13px] pointer-events-none" />

                <div className="w-full max-w-[320px] lg:max-w-[1200px] flex flex-col lg:flex-row items-start lg:items-center gap-8 lg:gap-12 relative z-10">
                    <div className="w-full lg:flex-1 flex flex-col items-start gap-6 lg:gap-20 lg:max-w-[716px] relative z-10">
                        <div className="flex flex-col gap-4 w-full">
                            <TextBadge className='w-max'>Transparency</TextBadge>
                            <TitleLarge className="text-white max-w-full lg:max-w-[506px]">
                                We Keep It <span className="text-primary">Real</span>
                            </TitleLarge>
                        </div>

                        <div className="w-full flex flex-col gap-6 lg:gap-12 max-w-[320px] lg:max-w-none">
                            <div className="flex flex-col gap-3 lg:gap-4">
                                <TitleMedium className="text-white">
                                    Smart Contract <span className="text-primary">Audits</span>
                                </TitleMedium>
                                <BodyRegular className="text-white/80 lg:text-white/60">
                                    Reports published publicly prior to auction launch.
                                </BodyRegular>
                            </div>

                            <div className="flex flex-col gap-3 lg:gap-4">
                                <TitleMedium className="text-white">
                                    Liquidity & Treasury <span className="text-primary">Tracking</span>
                                </TitleMedium>
                                <BodyRegular className="text-white/80 lg:text-white/60">
                                    On-chain wallet verification and buyback logs.
                                </BodyRegular>
                            </div>

                            <div className="flex flex-col gap-3 lg:gap-4">
                                <TitleMedium className="text-white">
                                    Education Fund <span className="text-primary">Reports</span>
                                </TitleMedium>
                                <BodyRegular className="text-white/80 lg:text-white/60">
                                    Annual impact data and fund allocations.
                                </BodyRegular>
                            </div>

                            <div className="flex flex-col gap-3 lg:gap-4">
                                <TitleMedium className="text-white">
                                    Governance <span className="text-primary">Logs</span>
                                </TitleMedium>
                                <BodyRegular className="text-white/80 lg:text-white/60">
                                    All proposals and results visible on-chain.
                                </BodyRegular>
                            </div>
                        </div>

                        <PrimaryButton className="w-full lg:w-96">
                            View All Reports
                        </PrimaryButton>
                    </div>

                    <div className="flex w-full lg:flex-1 items-center justify-center relative -top-80 lg:top-auto z-0">
                        <img 
                            className="absolute -top-60 -right-28 lg:right-0 w-48 h-auto lg:w-[714px]" 
                            src={HeroImage}
                            alt="Transparency section image"
                        />
                    </div>
                </div>
            </section>
        </div>
    );
};